import Notification from './Components/Notification';
import router from './Routes/RouterPaths'
import {
  RouterProvider,
} from "react-router-dom";

const App = () => {
  return (
    <div>
      <Notification></Notification>
     <RouterProvider  router={router}/>
    </div>
  )
}
export default App